export default __webpack_public_path__ + "static/media/queenofpeace.2102249a.jpg";